/**
 * A promise that resolves once the global edulab JS scope has loaded.
 * @type {Promise<unknown>}
 */
export const edulabGlobalPromise = new Promise(resolve => {
  let localReference = undefined

  try {
    // Resolve with the edulab
    resolve(edulab)
  } catch (error) {
    let edulabPageReadyInterval = setInterval(() => {
      try {
        // Try setting up a local reference
        // This will fail if the global edulab variable doesn't yet exist, letting the interval continue running
        localReference = edulab
      } catch (error) {
        // do nothing
      }

      if (localReference) {
        // Clear the interval and resolve
        clearInterval(edulabPageReadyInterval)
        resolve(localReference)
      }
    }, 50)
  }
})
